import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kve-input-header',
  templateUrl: './input-header.component.html',
  styleUrls: ['./input-header.component.scss']
})
export class InputHeaderComponent implements OnInit {
  @Input() title:string;
  
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  close(){
    this.onClose.emit();
  }

}
